import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
const wrapperIsDisabledCss = "wpwbfco";
const wrapperNoSpacingCss = "w1sec7tf";
const wrapperCss = "whgdz0w";
const Wrapper = forwardRef((props, ref) => {
  const {
    isDisabled,
    noSpacing,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsDisabledCss]: isDisabled,
    [wrapperNoSpacingCss]: noSpacing
  }, props.className)} />;
});
const ConferenceErrorMessage = ({
  kind,
  hasPendingUser,
  config
}) => {
  const {
    conferenceName,
    link
  } = config[kind];
  const LinkComponent = useCallback(({
    children
  }) => <Link href={link} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>, [link]);
  if (hasPendingUser) {
    return I18n.t('publisher.event_types.location.conferencing_pending_user', {
      conferencing_name: conferenceName
    });
  }
  if (kind === 'google_conference') {
    return HtmlParser(I18n.t('publisher.event_types.location.google_conference.calendar_connection_warning'), {
      LinkComponent
    });
  }
  return HtmlParser([I18n.t('publisher.event_types.location.conferencing_not_connected', {
    conferencing_name: conferenceName
  }), I18n.t('publisher.event_types.location.visit_conferencing_integration_html', {
    conferencing_name: conferenceName
  })].join('&nbsp;'), {
    LinkComponent
  });
};
export const ConferenceError = ({
  kind,
  hasPendingUser = false,
  ...props
}) => {
  const config = {
    zoom_conference: {
      conferenceName: 'Zoom',
      link: '/integrations/zoom'
    },
    gotomeeting_conference: {
      conferenceName: 'GoTo Meeting',
      link: '/integrations/gotomeeting'
    },
    microsoft_teams_conference: {
      conferenceName: 'Microsoft Teams',
      link: '/integrations/microsoft_teams'
    },
    webex_conference: {
      conferenceName: 'Webex',
      link: '/integrations/webex'
    },
    google_conference: {
      conferenceName: 'Google',
      link: '/app/availability/connected_calendars'
    }
  };
  return <Wrapper {...props}>
      <ConferenceErrorMessage kind={kind} hasPendingUser={hasPendingUser} config={config} />
    </Wrapper>;
};

require("./conference_error.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./conference_error.js");